<template>
  <div>
    <Form :data="item" :isSubmitting="isSubmitting" @submit="update" />
  </div>
</template>

<script>
import { onMounted } from '@vue/composition-api/dist/vue-composition-api'
import Form from '../shared/Form.vue'
import useProcessEdit from './useProcessEdit'

export default {
  components: {
    Form,
  },
  setup() {
    const { update, show, item, isSubmitting } = useProcessEdit()

    onMounted(show)

    return {
      update,
      show,
      item,
      isSubmitting,
    }
  },

}
</script>
